import React, {useState, useEffect} from 'react'
import styled from 'styled-components'
import {useSelector} from 'react-redux'
import {PrimaryButton} from '../components/UI/PrimaryButton'
import {colors} from '../styles/colors'
import {useFirebase} from 'react-redux-firebase'
import IMask from 'imask';
import {Loading} from '../components/UI/Loading'

const Container = styled.div`

    width: 100%;
    max-width: 767.98px;
    margin: 0 auto;

    // INCLUDED CLASSES:
    .input-block {
        margin-bottom: 3.75rem;
    }
    .photo-input {
        display: flex;
        margin-bottom: 3.75rem;
        .cross-button {
            margin-left: 2rem;

            svg {
                width: 2rem;
                height: 2rem;
                line {
                    stroke: ${colors.dark_blue};
                }
            }
            :hover {
                svg line {
                    stroke: ${colors.red};
                }
            }
        }
        input {
            display: none;
        }
    }
    .input-description, p {
        font-family: 'SF UI Text', sans-serif;
        font-weight: 400;
        font-size: 2rem;
        line-height: 160%;
        color: ${colors.dark_blue};
        margin-bottom: 1rem;
    }
    .input-description {
        width: 300px;
    }
    .input {
        width: 100%;
        height: 55px;
        color: ${colors.dark_blue};

        padding-left: 2.5rem; 

        font-family: 'SF UI Text', sans-serif;
        font-weight: 300;
        font-size: 2.5rem;
        line-height: 150%;

        outline: none;

        ::placeholder {
            font-family: 'SF UI Text',sans-serif;
            font-weight: 300;
            font-size: 2.5rem;
            line-height: 150%;    
            color: ${colors.dark_blue};
        }

    }
    .submit-button {
        margin: 0 auto;
        margin-bottom: 3rem;
    }
    .reset-button {
        text-align: center;
        margin-bottom: 2rem;
        cursor: pointer;
        :hover {
            color: ${colors.red};
        }
    }
    .preloader {
        display: flex;
        justify-content: center;
    }

    .contact-with-developer,
    .contact-with-developer-link {
        font-family: 'SF UI Text', sans-serif;
        font-weight: 300;
        font-size: 2.5rem;
        line-height: 150%;
        text-align: center;

        color: ${colors.dark_blue};
    }
    .developer-links {
        display: flex;
        max-width: 300px;
        justify-content: space-between;
        margin: 0 auto;
    }
    .contact-with-developer-link {
        transition: all .5s;

        :hover {
            color: ${colors.red};
        }
    }

`

export const MainData = () => {

    const database = useFirebase().ref('main_data')

    const main_data = useSelector(state => state.firebase.data.main_data)

    const [defaultDataWasSet, setDefaultDataWasSet] = useState(false)
    const [loading, setLoading] = useState(false)

    const [privacyPolicy, setPrivacyPolicy] = useState('')
    const [address, setAddress] = useState('')
    const [legalAddress, setLegalAddress] = useState('')
    const [inn, setInn] = useState('')
    const [kpp, setKpp] = useState('')
    const [tel, setTel] = useState('')
    const [email, setEmail] = useState('')
    const [emailForOrders, setEmailForOrders] = useState('')
    const [insta, setInsta] = useState('')

    let maskOptions = {
        mask: '+{7} (000) 000-00-00'
    };
    const tel_input = document.querySelector('input[type="tel"]')
    if (tel_input) {
        IMask(tel_input, maskOptions);
    }

    async function handleSubmit() {

        const data = {
            privacy_policy: privacyPolicy,
            legal_address: legalAddress,
            address,
            email,
            email_for_orders: emailForOrders,
            inn,
            kpp,
            insta,
            tel,
        }

        try {
            await database.set(data)
            setLoading(false)
            alert('Данные успешно обновлены')
        } catch (err) {
            alert(err)
        }

    }

    function setDefaultData(data) {

        setPrivacyPolicy(data.privacy_policy)
        setLegalAddress(data.legal_address)
        setAddress(data.address)
        setTel(data.tel)
        setInn(data.inn)
        setKpp(data.kpp)
        setInsta(data.insta)
        setEmail(data.email)
        setEmailForOrders(data.email_for_orders)

        setDefaultDataWasSet(true)
    }

    useEffect(() => {

        if (main_data && !defaultDataWasSet) {
            setDefaultData(main_data)
        }

    })

    return (
        <Container>
            <InputBlock value={legalAddress} setValue={setLegalAddress} description='Юридический адрес'/>
            <InputBlock value={address} setValue={setAddress} description='Адрес'/>
            <InputBlock type='tel' value={tel} setValue={setTel} description='Контактный телефон'/>
            <InputBlock value={inn} setValue={setInn} description='ИНН'/>
            <InputBlock value={kpp} setValue={setKpp} description='КПП'/>
            <InputBlock type='email' value={email} setValue={setEmail} description='E-mail'/>
            <InputBlock type='email' value={emailForOrders} setValue={setEmailForOrders}
                        description='E-mail для заказов'/>
            <InputBlock value={insta} setValue={setInsta} description='Instagram @'/>

            <div className="buttons">
                <p className='reset-button' onClick={ ()=> setDefaultDataWasSet(false) }>Сбросить изменения</p>
                {loading
                    ? <Loading/>
                    : <PrimaryButton className='submit-button' onClick={handleSubmit}>Применить</PrimaryButton>
                }
            </div>

            <p className='contact-with-developer'>Есть вопросы? Связаться с разработчиком в:</p>
            <div className="developer-links">
                <a className='contact-with-developer-link' href="https://wa.me/79649164178" target="_blank"
                   rel="noopener noreferrer">WhatsApp</a>
                <a className='contact-with-developer-link' href="https://t.me/andrew_gubin" target="_blank"
                   rel="noopener noreferrer">Telegram</a>
            </div>

        </Container>
    )
}

function InputBlock({description, value, setValue, type}) {
    return (
        <div className="input-block">
            <p className='input-description'> {description} </p>
            <input className='input' placeholder={description} type={type ? type : "text"} value={value}
                   onChange={(e) => setValue(e.target.value)}/>
        </div>
    )
}
